"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _preactCompat = require("preact-compat");

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _topicService = require("../services/topicService");

var _modal = _interopRequireWildcard(require("@insided/deprecated-preact-components/design-system-components/modal"));

var _inputUnit = _interopRequireDefault(require("@insided/deprecated-preact-components/design-system-components/input-unit"));

var _Filters = require("../../ContentOverviews/Filters");

var _logger = require("@insided/shared/services/logger");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var CopyTopicModal = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(CopyTopicModal, _PureComponent);

  var _super = _createSuper(CopyTopicModal);

  function CopyTopicModal() {
    var _this;

    (0, _classCallCheck2.default)(this, CopyTopicModal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      isLoading: false,
      selectedCategoryIds: []
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onCopyToForum", /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(data) {
        var _this$props, onShowAlert, onClose, contentType, topicId;

        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this$props = _this.props, onShowAlert = _this$props.onShowAlert, onClose = _this$props.onClose, contentType = _this$props.contentType, topicId = _this$props.topicId;

                _this.setState({
                  isLoading: true
                });

                _context.prev = 2;
                _context.next = 5;
                return (0, _topicService.copyTopicToForum)(contentType, topicId, (0, _toConsumableArray2.default)(data));

              case 5:
                onShowAlert('success', 'The topic has been successfully copied to the selected forum(s)');
                onClose();
                _context.next = 13;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](2);

                _logger.logger.error(_context.t0, {
                  component: 'CopyTopicModal',
                  action: 'copyTopicToForum'
                });

                onShowAlert('error');

              case 13:
                _this.setState({
                  isLoading: false
                });

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[2, 9]]);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    return _this;
  }

  (0, _createClass2.default)(CopyTopicModal, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          onClose = _this$props2.onClose,
          categoriesV2 = _this$props2.categoriesV2;
      var _this$state = this.state,
          selectedCategoryIds = _this$state.selectedCategoryIds,
          isLoading = _this$state.isLoading;
      /** @deprecated - create new multi-select searchable dropdown in @insided/control/uikit - see CAN-1254 */

      var _createPublishedInFil = (0, _Filters.createPublishedInFilter)(categoriesV2),
          CategoriesSelector = _createPublishedInFil.component,
          items = _createPublishedInFil.items,
          id = _createPublishedInFil.id,
          name = _createPublishedInFil.name;

      return (0, _preact.h)("div", {
        className: "copy-topic-modal"
      }, (0, _preact.h)(_modal.default, {
        onClose: onClose,
        isControl: true
      }, (0, _preact.h)(_modal.ModalHeader, {
        title: "Copy to forum"
      }), (0, _preact.h)(_modal.ModalBody, null, (0, _preact.h)(_inputUnit.default, {
        label: "Select the forum(s) where you wish to copy the topic to:",
        isControl: true
      }, (0, _preact.h)("div", {
        className: "copy-topic-dropdown__list"
      }, (0, _preact.h)(CategoriesSelector, {
        id: id,
        name: name,
        items: items,
        selectedFilterItems: selectedCategoryIds !== null && selectedCategoryIds !== void 0 ? selectedCategoryIds : []
      }, function (_ref2) {
        var isApplyButtonDisabled = _ref2.isApplyButtonDisabled,
            data = _ref2.data;
        return (0, _preact.h)("div", null, (0, _preact.h)("hr", null), (0, _preact.h)("div", {
          className: "copy-topic-modal__buttons"
        }, (0, _preact.h)(_Button.default, {
          size: "medium",
          variant: "brand",
          "data-qa": "copy-to-forum",
          title: "Copy to forum",
          disabled: isApplyButtonDisabled || isLoading,
          onClick: /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
            return _regenerator.default.wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    _context2.next = 2;
                    return _this2.onCopyToForum(data);

                  case 2:
                    return _context2.abrupt("return", _context2.sent);

                  case 3:
                  case "end":
                    return _context2.stop();
                }
              }
            }, _callee2);
          }))
        }), (0, _preact.h)(_Button.default, {
          size: "medium",
          title: "Cancel",
          onClick: onClose
        })));
      }))))));
    }
  }]);
  return CopyTopicModal;
}(_preactCompat.PureComponent);

var _default = CopyTopicModal;
exports.default = _default;